

import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PreventBack = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleBackButton = () => {
      if (location.pathname === "/home") {
        navigate(1);
      }
    };

    if (location.pathname === "/home") {
      window.history.pushState(null, "", window.location.href);
      window.addEventListener("popstate", handleBackButton);
    }

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate, location]);

  return null;
};

export default PreventBack;
